import { apiGet } from './api';

export type EngagementSummary = {
  activity: {
    lastLoginAt: string | null;
    lastActivityAt: string | null;
    registeredAt: string;
    activeDaysLast30: number;
    totalSessions: number;
    averageSessionDurationMs: number;
    totalSessionTimeMs: number;
  };
  tracking: {
    uniqueDocumentsViewed: number;
    totalDocumentViews: number;
    totalDocumentTimeMs: number;
    mostViewedDocuments: Array<{
      documentId: string;
      documentCode?: string;
      documentTitle?: string;
      documentDomain?: string;
      viewCount: number;
      totalTimeMs: number;
    }>;
    learningWeek: Array<{
      date: string;
      documentCount: number;
      totalTime: number;
      uniqueDocuments: number;
    }>;
  };
  progression: {
    currentLevel: number;
    totalExperience: number;
    totalBadges: number;
    totalDocuments: number;
    completedDocuments: number;
    inProgressDocuments: number;
    xpBreakdown: Array<{ source: string; label: string; amount: number }>;
    recentXp: Array<{
      amount: number;
      source: string;
      timestamp: string;
    }>;
  };
  exercises: {
    totalAttempts: number;
    passed: number;
    passRate: number;
  };
  courseSessions: {
    count: number;
    lastSessionAt: string | null;
    lastSessionStatus: string | null;
  };
  generatedAt: string;
};

export async function getUserEngagementSummary(userId: string) {
  return apiGet<{ success: boolean; data: EngagementSummary }>(
    `/api/v1/engagement/user/${userId}/summary`
  );
}
